import Vue from 'PublicJs/vue-bootstrap';
import JobsTicker from 'PublicJs/Components/JobsTicker';

let tickerList = document.getElementById('featured-jobs');

if (tickerList !== null) {
	new Vue({
		el: '#featured-jobs',
		components: {
			'jobs-ticker': JobsTicker
		},
		data: {
			listData: [],
		},
		created: function () {
			this.getJobs();
		},
		methods: {
			getJobs() {
				let domData =  document.getElementById('ticker-list').getElementsByTagName('li');
				this.listData = Array.from(domData);
			}
		},
		template: `
		<jobs-ticker v-bind:items="this.listData"></jobs-ticker>
`
	});

}
